// Live-tunable combat balance. The panel's sliders mutate these at runtime; tanks.ts + army.ts
// read them at spawn (HP) and at damage time (resistances). HP changes apply to NEW spawns (units
// keep the HP they spawned with); resistances apply immediately. The *Dmg fields are damage-taken
// MULTIPLIERS — lower = tougher (0.35 => the unit takes 35% of that damage type).
export const balance = {
  soldierHp: 100, // little-people health
  giantHp: 550, // giants are heavy bruisers
  giantBlastDmg: 0.35, // explosion damage giants take (bullets/melee are always full)
  tankHpMul: 3, // multiplies each tank type's base health
  tankBulletDmg: 0.35, // direct-shot damage tanks take
  tankBlastDmg: 0.45, // explosion damage tanks take
  // ---- rarity (how many of each appear on the field) ----
  tankMax: 36, // max active tanks total (pool is 18 types × 2 teams = 36)
  giantMax: 5, // max active giants PER TEAM
  specialFrac: 0.3, // how hard the spawner TRIES for ranged specialists (they still cost UP; low = grunt-heavy filler)
  // ---- Unit Points (UP) economy — the "filler" system ----
  // Each team banks UP over time and spends it on non-free units. The plain melee infantryman is
  // FREE (the filler); everything else costs UP, so specials stay rare amid a sea of grunts. When a
  // team can't afford the special it wants, it spawns nothing and banks the UP (bursty specials).
  // Costs are PLACEHOLDERS (to be derived systematically later): role costs live in entities/roles.ts,
  // tank cost is computed from hp in entities/tanks.ts, giant cost is below.
  upRegen: 30, // UP gained per second, per team (both teams equal). specialFrac gates the grunt/ranged
  //             mix; regen just funds how often the rarer heavies (giants/tanks) can be afforded.
  upCap: 500, // max banked UP
  upStart: 80, // UP each team starts a level with
  giantCost: 100, // UP to field one giant
};
